import React, { useState, useEffect } from 'react';
import logo from './img/logo.png';
import heroHome from './img/hero-home.png';
import partnerimg from './img/partners.jpeg';
import genlife from './img/Genlife logo.jpg';
import machis from './img/logo-1.jpg'
import appointmentBg from './img/Apointement.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp as faWhatsappBrand } from '@fortawesome/free-brands-svg-icons';
import { 
  faPuzzlePiece, 
  faBolt, 
  faBaby, 
  faComments, 
  faBrain,
  faBook, 
  faHeart, 
  faUsers, 
  faHandsHelping, 
  faSmile, 
  faShieldAlt, 
  faChartLine, 
  faHands,
  faMapMarkerAlt,
  faPhone,
  faEnvelope,
  faHome,
  faTree,
  faEllipsisV,
  faTimes
} from '@fortawesome/free-solid-svg-icons';
import { 
  faFacebookF, 
  faTwitter, 
  faInstagram, 
  faLinkedinIn 
} from '@fortawesome/free-brands-svg-icons';
import './App.css';

function App() {
  const [activeService, setActiveService] = useState('aba');
  const [appointmentForm, setAppointmentForm] = useState({
    name: '',
    email: '',
    phone: '',
    childAge: '',
    service: 'aba',
    message: ''
  });
  const [submitStatus, setSubmitStatus] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showAppointmentPopup, setShowAppointmentPopup] = useState(false);
  
  // Add state for contact form
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [contactStatus, setContactStatus] = useState({});

  // Initialize EmailJS
  useEffect(() => {
    // Show appointment popup when website loads
    const timer = setTimeout(() => {
      setShowAppointmentPopup(true);
    }, 2000); // Show after 2 seconds
    
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    
    if (isMobile) {
      const appointmentSection = document.getElementById('appointment');
      if (appointmentSection) {
        setTimeout(() => {
          appointmentSection.scrollIntoView({ behavior: 'smooth' });
        }, 500);
      }
    }
    
    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', checkIfMobile);
    };
  }, [isMobile]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const closeAppointmentPopup = () => {
    setShowAppointmentPopup(false);
  };

  const services = {
    aba: {
      title: 'ABA Therapy',
      image: require('./img/aba-therapy.jpg'),
      content: `Applied Behavior Analysis (ABA) therapy is a trusted method that helps children with autism develop essential life skills. It uses positive encouragement to teach new behaviors step by step, making learning easier and more enjoyable.
      
      Every child receives a personalized plan, designed by a trained therapist, that focuses on their unique strengths and needs. Activities may include practicing eye contact, learning to follow instructions, improving communication, and building daily routines.
      
      With regular guidance and support, ABA therapy helps children develop confidence, enhance social skills, and achieve lasting progress in their everyday lives.`
    },
    speech: {
      title: 'Speech Therapy',
      image: require('./img/speech-therapy.jpeg'),
      content: `Speech therapy helps children with autism learn to communicate better—both with words and through gestures, expressions, or body language. At Blessed Kids, our speech therapists design engaging, personalized activities to help children practice speaking, listening, and expanding their vocabulary.
      
      Therapy also helps with challenges like stuttering, unclear speech, or delayed language. With regular support, children become more confident in expressing themselves and find it easier to connect with family, friends, and others around them.`
    },
    occupational: {
      title: 'Occupational Therapy',
      image: require('./img/occupational-therapy.jpeg'),
      content: `Occupational therapy helps children with autism learn everyday skills like eating, dressing, writing, and playing with others. At Blessed Kids, our therapists make a personalized plan for each child, focusing on their strengths and areas that need support.
      
      Therapy also helps with sensory issues, such as being sensitive to sounds, touch, or movement. Through fun and engaging activities, children practice coordination, focus, and independence. With regular guidance, occupational therapy helps children feel more confident and manage daily life more smoothly.`
    },
    education: {
      title: 'Special Education',
      image: require('./img/special-education.jpeg'),
      content: `Special education helps children with autism and other learning needs by giving them the right kind of support for their growth. At Blessed Kids, our special educators make personalized learning plans that focus on academics, communication, social skills, and daily life activities.
      
      Using simple, structured methods and tools, children learn at their own pace while building confidence and independence. With regular guidance in a caring environment, special education helps children learn better, grow stronger, and achieve their best.`
    },
    physio: {
      title: 'Physiotherapy',
      image: require('./img/physiotherapy.jpeg'),
      content: `Physiotherapy helps children with autism improve how they move, play, and stay active. At Blessed Kids, our physiotherapists create fun, personalized activities to build strength, balance, posture, and coordination.
      
      Therapy may include exercises for walking, running, using hands for small tasks, and improving body control. It also helps with sensory issues and planning movements, making everyday tasks easier. With regular sessions, physiotherapy builds children's confidence, independence, and physical health.`
    }
  };

  const treatmentFocus = [
    {
      icon: faPuzzlePiece,
      title: 'Autism Spectrum Disorder (ASD)',
      content: `Autism Spectrum Disorder, or ASD, is a condition that affects the way children communicate, behave, and connect with others. Every child with autism is unique—some may have special strengths like memory or problem-solving, while others may find speaking, socializing, or adjusting to changes more challenging.
      
      Because autism is a "spectrum," no two children are the same. With the right support and therapies, children with ASD can learn, grow, and achieve meaningful progress in their daily lives.`
    },
    {
      icon: faBolt,
      title: 'ADHD',
      content: `ADHD (Attention-Deficit/Hyperactivity Disorder) is a condition that makes it harder for children to pay attention, sit still, and control their impulses. This can sometimes make schoolwork, daily routines, or friendships more challenging.
      
      With the right support and early help, children with ADHD can learn to focus better, manage their energy, and feel more confident in daily life. Therapies, guidance for parents, and consistent routines all play an important role in helping children succeed.`
    },
    {
      icon: faBaby,
      title: 'Developmental Delay',
      content: `Developmental delay means a child is taking longer than expected to learn skills like talking, walking, or socializing. It doesn't mean they cannot learn—it just means they may need more time and support.
      
      With early therapies, structured routines, and encouragement, children with developmental delay can make steady progress and grow more confident in their abilities.`
    },
    {
      icon: faComments,
      title: 'Speech Delay',
      content: `Speech delay means a child is taking longer than expected to start talking or using words to express themselves. Some children may speak fewer words, begin speaking later, or find it harder to join conversations and interact socially.
      
      Early support through speech therapy and a nurturing environment can make a big difference. With regular practice and encouragement, children with speech delay can gradually improve their communication skills and gain confidence in expressing themselves.`
    },
    {
      icon: faBrain,
      title: 'Epilepsy',
      content: `Epilepsy is a condition where unusual brain activity causes seizures. In children, seizures may look like staring spells, sudden jerks, or shaking movements. It is more common in children with autism.
      
      With proper care, treatment, and regular medical support, children with epilepsy can stay safe, healthy, and continue learning and growing in their daily lives.`
    },
    {
      icon: faBook,
      title: 'Learning Disabilities',
      content: `Learning disabilities mean a child may need extra support with skills like reading, writing, or problem-solving. It doesn't mean they learn less—it simply means they learn in a different way.
      
      With patience, the right tools, and consistent support, children with learning disabilities can build their skills, grow in confidence, and succeed at their own pace.`
    }
  ];

  const features = [
    {
      icon: faHeart,
      title: 'Personalized Care',
      description: 'Every child receives an individualized plan tailored to their needs.'
    },
    {
      icon: faUsers,
      title: 'Skilled & Experienced Team',
      description: 'Professionals with expertise in child development and therapy.'
    },
    {
      icon: faHandsHelping,
      title: 'Comprehensive Support',
      description: 'Focus on communication, learning, social, and life skills.'
    },
    {
      icon: faSmile,
      title: 'Child-Friendly Approach',
      description: 'Fun, engaging, and interactive methods for better learning.'
    },
    {
      icon: faShieldAlt,
      title: 'Safe & Nurturing Environment',
      description: 'A space where children feel secure and supported.'
    },
    {
      icon: faChartLine,
      title: 'Ongoing Progress Tracking',
      description: 'Regular monitoring to ensure steady growth.'
    },
    {
      icon: faHands,
      title: 'Compassionate Care',
      description: 'A warm, patient, and encouraging learning atmosphere for every child.'
    }
  ];

  const handleServiceClick = (service) => {
    setActiveService(service);
    setAppointmentForm({...appointmentForm, service});
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAppointmentForm({...appointmentForm, [name]: value});
  };

  // Handle contact form input changes
  const handleContactInputChange = (e) => {
    const { name, value } = e.target;
    setContactForm({...contactForm, [name]: value});
  };

  // Base URL for your API
const API_BASE = 'https://api.blessedkids.in';

// Appointment form submission
const handleSubmit = async (e) => {
  e.preventDefault();
  setSubmitStatus({ loading: true, message: '' });
  
  try {
    const response = await fetch(`${API_BASE}/appointments`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(appointmentForm)
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    if (data.success) {
      setSubmitStatus({ 
        success: true, 
        message: data.message 
      });
      // Reset form
      setAppointmentForm({
        name: '',
        email: '',
        phone: '',
        childAge: '',
        service: 'aba',
        message: ''
      });
      // Close popup after successful submission
      setTimeout(() => {
        setShowAppointmentPopup(false);
      }, 2000);
    } else {
      throw new Error(data.message);
    }
  } catch (error) {
    setSubmitStatus({ 
      success: false, 
      message: error.message || 'Error submitting form. Please try again.' 
    });
  }
};

// Contact form submission
const handleContactSubmit = async (e) => {
  e.preventDefault();
  setContactStatus({ loading: true, message: '' });
  
  try {
    const response = await fetch(`${API_BASE}/contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(contactForm)
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    if (data.success) {
      setContactStatus({ 
        success: true, 
        message: data.message 
      });
      // Reset form
      setContactForm({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
    } else {
      throw new Error(data.message);
    }
  } catch (error) {
    setContactStatus({ 
      success: false, 
      message: error.message || 'Error sending message. Please try again.' 
    });
  }
};

  return (
    <div className="App">
      {/* Appointment Popup */}
      {showAppointmentPopup && (
        <div className="appointment-popup-overlay">
          <div className="appointment-popup" style={{ 
        backgroundImage: `url(${appointmentBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundColor: '#f8f9fa'
      }}>
            <button className="popup-close-btn" onClick={closeAppointmentPopup}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
            <div className="appointment-popup-content">
              <h3>Book Your Appointment</h3>
              <p style={{color:'white'}}>We're here to help your child thrive. Book an appointment with our specialists to discuss your child's needs.</p>
              
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <input 
                    type="text" 
                    id="popup-name" 
                    name="name"
                    placeholder="Enter your full name" 
                    value={appointmentForm.name}
                    onChange={handleInputChange}
                    required 
                  />
                </div>
                
                <div className="form-group">
                  <input 
                    type="email" 
                    id="popup-email" 
                    name="email"
                    placeholder="Enter your email address" 
                    value={appointmentForm.email}
                    onChange={handleInputChange}
                    required 
                  />
                </div>
                
                <div className="form-group">
                  <input 
                    type="tel" 
                    id="popup-phone" 
                    name="phone"
                    placeholder="Enter your phone number" 
                    value={appointmentForm.phone}
                    onChange={handleInputChange}
                    required 
                  />
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <input 
                      type="number" 
                      id="popup-age" 
                      name="childAge"
                      placeholder="Age" 
                      min="0" 
                      max="18" 
                      value={appointmentForm.childAge}
                      onChange={handleInputChange}
                      required 
                    />
                  </div>
                  
                  <div className="form-group">
                    <select 
                      id="popup-service" 
                      name="service"
                      value={appointmentForm.service}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select Service</option>
                      <option value="ABA Therapy">ABA Therapy</option>
                      <option value="Speech Therapy">Speech Therapy</option>
                      <option value="Occupational Therapy">Occupational Therapy</option>
                      <option value="Special Education">Special Education</option>
                      <option value="Physiotherapy">Physiotherapy</option>
                      <option value="General Consultation">General Consultation</option>
                    </select>
                  </div>
                </div>
                
                <div className="form-group">
                  <textarea 
                    id="popup-message" 
                    name="message"
                    rows="3" 
                    placeholder="Any additional information you'd like to share"
                    value={appointmentForm.message}
                    onChange={handleInputChange}
                  ></textarea>
                </div>
                
                {submitStatus.message && (
                  <div className={`form-message ${submitStatus.success ? 'success' : 'error'}`}>
                    {submitStatus.message}
                  </div>
                )}
                
                <button type="submit" className="btn btn-primary" disabled={submitStatus.loading}>
                  {submitStatus.loading ? 'Booking Appointment...' : 'Book Appointment'}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Header */}
      <header>
        <div className="container header-container">
          <div className="logo">
            <div className="logo-icon">
              <img src={logo} width="100" height="100" alt="Blessed Kids Logo"></img>
            </div>
            <span className="logo-text">Blessed Kids</span>
          </div>
          
          {/* Regular navigation (hidden on mobile) */}
          <nav className="desktop-nav">
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#treatment">Treatment Focus</a></li>
              <li><a href="#why-choose">Why Choose Us</a></li>
              <li><a href="#appointment">Book Appointment</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </nav>
          
          {/* Mobile menu button (three dots) */}
          <button className="mobile-menu-btn" onClick={toggleMobileMenu}>
            <FontAwesomeIcon icon={faEllipsisV} />
          </button>
          
          {/* Mobile menu overlay */}
          <div className={`mobile-menu-overlay ${isMobileMenuOpen ? 'active' : ''}`} onClick={closeMobileMenu}></div>
          
          {/* Mobile menu content */}
          <div className={`mobile-menu-content ${isMobileMenuOpen ? 'active' : ''}`}>
            <button className="mobile-close-btn" onClick={closeMobileMenu}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
            <nav className="mobile-nav">
              <ul>
                <li><a href="#home" onClick={closeMobileMenu}>Home</a></li>
                <li><a href="#about" onClick={closeMobileMenu}>About Us</a></li>
                <li><a href="#services" onClick={closeMobileMenu}>Services</a></li>
                <li><a href="#treatment" onClick={closeMobileMenu}>Treatment Focus</a></li>
                <li><a href="#why-choose" onClick={closeMobileMenu}>Why Choose Us</a></li>
                <li><a href="#appointment" onClick={closeMobileMenu}>Book Appointment</a></li>
                <li><a href="#contact" onClick={closeMobileMenu}>Contact</a></li>
              </ul>
            </nav>
          </div>
        </div>
      </header>
      {/* Hero Section with Background Image */}
      <section className="hero" id="home">
        <div className="hero-overlay">
          <div className="container hero-content">
            {/* Left Side - Content */}
            <div className="hero-text">
             <img src={heroHome} style={{width:'100%',height:'460px'}}/>
              
              {/* <div className="hero-buttons">
                <a href="#appointment" className="btn btn-primary">Book an Appointment</a>
                <a href="tel:+919821070068" className="btn btn-call-now">
                  <FontAwesomeIcon icon={faPhone} /> Call Now
                </a>
              </div> */}
            </div>
            
           
          </div>
        </div>
        
       

      </section>

<section className="about" id="home" style={{ backgroundColor: '#f8f9fa',marginTop:'-10px' }}>
  <div className="container">
    <h1 style={{textAlign:'center'}}>Celebrating Every Child's Brilliance</h1>
    <div className="about-content">
      <div className="about-text">
      <p>Welcome to Blessed Kids - A place where therapy meets heart. At Blessed Kids, we specialize in supporting children with autism, ADHD, developmental delays, and learning challenges through personalized, multidisciplinary care. Our team of expert therapists and educators work hand-in-hand with families to unlock each child's potential—one joyful step at a time.</p>
              <p>Whether you're seeking speech therapy, occupational support, behavioral guidance, or early intervention, you'll find a nurturing space here where your child is seen, heard, and celebrated.</p>
      </div>
    </div>
  </div>
</section>

      {/* About Us Section with Fixed Image */}
<section className="about" id="about" style={{ backgroundColor: '#f8f9fa' }}>
  <div className="container">
    <h2 className="ection-title-abount" style={{textAlign:'center'}}>About Blessed Kids</h2>
    <div className="about-content">
      <div className="about-text">
        <p>At <em>Blessed Kids</em>, we believe that every child is a gift—full of promise, potential, and purpose. As part of a healthcare legacy that began in 2001, our journey has evolved from pioneering nutraceuticals with "GenLife" (launched in 2001) to delivering holistic health services through "Genhealth" (established in 2021). Today, we take a deeply meaningful step forward with <em>Blessed Kids</em>, a specialized therapy center dedicated to supporting children with developmental challenges.</p>
        
        <p>Our center is built on compassion, science, and a commitment to personalized care. We offer a comprehensive range of therapies—including ABA, speech, occupational, physiotherapy, and special education—designed to nurture each child's unique strengths. Whether a child is navigating autism, ADHD, developmental delays, or learning disabilities, we provide evidence-based interventions in a safe, engaging, and child-friendly environment.</p>
        
        <p>What sets us apart is our belief that these children are not defined by their diagnoses—they are <em>blessed</em> with extraordinary perspectives and abilities. Our team of skilled professionals works closely with families to create individualized plans that foster growth across communication, behavior, motor skills, and learning.</p>
        
        <p>At <em>Blessed Kids</em>, we don't just offer therapy—we offer hope, progress, and a space where every child is celebrated for who they are and supported in becoming all they can be.</p>
      </div>
    </div>
  </div>
</section>
      {/* Services Section */}
      <section className="services" id="services">
        <div className="container">
          <h2 className="section-title">Our Range of Therapeutic Services</h2>
          <div className="services-container">
            <div className="service-list">
              {Object.keys(services).map((key) => (
                <div 
                  key={key} 
                  className={`service-tab ${activeService === key ? 'active' : ''}`}
                  onClick={() => handleServiceClick(key)}
                >
                  <h3>{services[key].title}</h3>
                  <p>{key === 'aba' ? 'Applied Behavior Analysis therapy' : 
                      key === 'speech' ? 'Improving communication skills' :
                      key === 'occupational' ? 'Developing daily living skills' :
                      key === 'education' ? 'Personalized learning plans' :
                      'Improving movement and coordination'}</p>
                </div>
              ))}
            </div>
            
            <div className="service-display">
              <div className="service-content active">
                <div className="service-image">
                  <img src={services[activeService].image} alt={services[activeService].title} style={{height:'350px'}} />
                </div>
                <div className="service-details">
                  <h3>{services[activeService].title}</h3>
                  <p>{services[activeService].content}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Treatment Focus Section with Vibrant Background */}
      <section className="treatment" id="treatment" style={{ backgroundImage: `url(${heroHome})`, backgroundRepeat:'no-repeat',backgroundSize: 'auto',backgroundColor: '#f8f9fa' }}>
        <div className="container">
          <h2 className="section-title-focus" style={{txtcolor:'#9D5BA4'}}>Our Treatment Focus</h2>
          <div className="treatment-grid">
            {treatmentFocus.map((item, index) => (
              <div key={index} className="treatment-card">
                <div className="treatment-icon">
                  <FontAwesomeIcon icon={item.icon} />
                </div>
                <h3>{item.title}</h3>
                <p>{item.content}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-choose" id="why-choose">
        <div className="container">
          <h2 className="section-title">Why Choose Us</h2>
          <p>At Blessed Kids, we understand that every child is unique. That's why we offer personalized care and therapies designed to meet each child's individual needs. Our team of experienced professionals uses proven, evidence-based methods to support children with autism and developmental challenges.</p>
          <p>We provide care in a safe, supportive, and child-friendly environment, helping children learn, grow, and thrive while giving families the guidance and encouragement they need.</p>
          
          <div className="additional-features">
            <p><FontAwesomeIcon icon={faTree} /> As soon as the child reaches the readiness level, we will also conduct outdoor activities to enhance their skills and confidence.</p>
            <p><FontAwesomeIcon icon={faHome} /> Blessed kids will also provide Home Sessions</p>
          </div>
          
          <h3 style={{marginTop: '40px', color: 'var(--primary-orange)'}}>Our Areas of Care</h3>
          <div className="features">
            {features.map((feature, index) => (
              <div key={index} className="feature">
                <div className="feature-icon">
                  <FontAwesomeIcon icon={feature.icon} />
                </div>
                <div className="feature-text">
                  <h4>{feature.title}</h4>
                  <p>{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

  {/* Appointment Section */}
<section className="appointment" style={{paddingLeft:'10px'}}>
  <div className="container">
    <div className="appointment-container">
      <div className="appointment-content">
        <h2>Book your Appointment</h2>
        <p>We're here to help your child thrive. Book an appointment with our specialists to discuss your child's needs and create a personalized treatment plan.</p>
        <p>Our team will contact you within 24 hours to confirm your appointment details.</p>
        
        
      </div>
       {/* Right Side - Form */}
            <div className="appointment-form desktop-form" style={{ backgroundImage: `url(${appointmentBg})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundColor: '#f8f9fa',paddingLeft:'20px' }}  id="appointment">
            
              <h3 style={{color:'#f8f9fa'}}>Get In Touch</h3>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <input 
                    type="text" 
                    id="name" 
                    name="name"
                    placeholder="Enter your full name" 
                    value={appointmentForm.name}
                    onChange={handleInputChange}
                    required 
                  />
                </div>
                
                <div className="form-group">
                  <input 
                    type="email" 
                    id="email" 
                    name="email"
                    placeholder="Enter your email address" 
                    value={appointmentForm.email}
                    onChange={handleInputChange}
                    required 
                  />
                </div>
                
                <div className="form-group">
                  <input 
                    type="tel" 
                    id="phone" 
                    name="phone"
                    placeholder="Enter your phone number" 
                    value={appointmentForm.phone}
                    onChange={handleInputChange}
                    required 
                  />
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <input 
                      type="number" 
                      id="age" 
                      name="childAge"
                      placeholder="Age" 
                      min="0" 
                      max="18" 
                      value={appointmentForm.childAge}
                      onChange={handleInputChange}
                      required 
                    />
                  </div>
                  
                  <div className="form-group">
                    <select 
                      id="service" 
                      name="service"
                      value={appointmentForm.service}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select Service</option>
                      <option value="ABA Therapy">ABA Therapy</option>
                      <option value="Speech Therapy">Speech Therapy</option>
                      <option value="Occupational Therapy">Occupational Therapy</option>
                      <option value="Special Education">Special Education</option>
                      <option value="Physiotherapy">Physiotherapy</option>
                      <option value="General Consultation">General Consultation</option>
                    </select>
                  </div>
                </div>
                
                <div className="form-group">
                  <textarea 
                    id="message" 
                    name="message"
                    rows="3" 
                    placeholder="Any additional information you'd like to share"
                    value={appointmentForm.message}
                    onChange={handleInputChange}
                  ></textarea>
                </div>
                
                {submitStatus.message && (
                  <div className={`form-message ${submitStatus.success ? 'success' : 'error'}`}>
                    {submitStatus.message}
                  </div>
                )}
                
                <button type="submit" className="btn btn-primary" disabled={submitStatus.loading}>
                  {submitStatus.loading ? 'Booking Appointment...' : 'Book Appointment'}
                </button>
              <a href="https://wa.me/918860708484" className="whatsapp-float" style={{
  // position: "fixed",
  right: "0px",        // Adjust as needed
  width: "55px",
  height: "55px",
  bottom: "-200px",       // Much closer to bottom
  zIndex: "9999",
  backgroundColor: "#25D366",
  color: "white",
  borderRadius: "50%",
  display: "flex",
  alignItems: "buttom",
  justifyContent: "center",
  fontSize: "28px",
  boxShadow: "0 4px 15px rgba(0, 0, 0, 0.3)",
  transition: "all 0.3s ease",
  textDecoration: "none"
}}>
                <FontAwesomeIcon icon={faWhatsappBrand} />
              </a>  
              
              </form>
              
            </div>
     
    </div>
  </div>
</section> 

      {/* Footer */}
      <footer id="contact">
        <div className="container">
          <div className="footer-grid">
            
            <div className="footer-col">
              <h3>Blessed Kids</h3>
              <p>Providing specialized therapeutic services for children with autism and developmental challenges. Helping each child reach their full potential.</p>
              <div className="social-links">
                <a href="#"><FontAwesomeIcon icon={faFacebookF} /></a>
                <a href="#"><FontAwesomeIcon icon={faTwitter} /></a>
                <a href="#"><FontAwesomeIcon icon={faInstagram} /></a>
                <a href="#"><FontAwesomeIcon icon={faLinkedinIn} /></a>
              </div>
                          
                    <div class="partners-section">
                        <h3>Our Partners</h3>
                        <div class="partner-logos">
                            <a href="https://www.genhealth.in/" target="_blank" class="partner-logo">
                                <img src={partnerimg} alt="GenHealth Partner Logo"/>
                            </a>
                            <a href="https://machis.co.in/" target="_blank" class="partner-logo">
                                <img src={machis} alt="Partner 2 Logo"/>
                            </a>
                            <a href="https://genlife.in/" target="_blank" class="partner-logo">
                                <img src={genlife} alt="Gen life"/>
                            </a>
                        </div>
                    </div>
                </div>
            <div className="footer-col">
              <h3>Quick Links</h3>
              <ul>
                <li><a href="#home">Home</a></li>
                <li><a href="#about">About Us</a></li>
                <li><a href="#services">Our Services</a></li>
                <li><a href="#treatment">Treatment Focus</a></li>
                <li><a href="#why-choose">Why Choose Us</a></li>
                <li><a href="#appointment">Book Appointment</a></li>
              </ul>
            </div>
            <div className="footer-col">
              <h3>Our Services</h3>
              <ul>
                <li><a href="#services">ABA Therapy</a></li>
                <li><a href="#services">Speech Therapy</a></li>
                <li><a href="#services">Occupational Therapy</a></li>
                <li><a href="#services">Special Education</a></li>
                <li><a href="#services">Physiotherapy</a></li>
              </ul>
            </div>
            <div className="footer-col">
              <h3>Contact Us</h3>
              <ul>
                <li><FontAwesomeIcon icon={faMapMarkerAlt} /> A- 244 First Floor Ambedkar Colony Mehrauli Gurugram Road near Andheria Mor</li>
                <li><FontAwesomeIcon icon={faMapMarkerAlt} /> Opposite Chattarpur Metro Station, New Delhi</li>
                <li><FontAwesomeIcon icon={faMapMarkerAlt} /> Delhi 110074</li>
                <li><FontAwesomeIcon icon={faPhone} /> +91 8860708484</li>
                <li><FontAwesomeIcon icon={faEnvelope} /> info@blessedkids.in</li>
                <li><FontAwesomeIcon icon={faMapMarkerAlt} />Timing 10:00 AM to 6:00 PM</li>
              </ul>
            </div>
          </div>
          <div className="copyright">
            <p>&copy; 2025 Blessed Kids. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;